import React from 'react'
import { connect } from 'react-redux'

let Announcer = ({ announcerMessages = [] }) => (
  <div className="visually-hidden">
    {announcerMessages.map(message => (
      <span role="alert">{message}</span>
    ))}
  </div>
)

export default connect(
  state => ({
    announcerMessages: state.app.announcerMessages
  })
)(Announcer)



// WEBPACK FOOTER //
// ./src/components/Announcer/Announcer.js